// extracted by mini-css-extract-plugin
module.exports = {"wrap":"DefinitionList_wrap__2n4wy","gutterBottom":"DefinitionList_gutterBottom__2ixXp","borderBottom":"DefinitionList_borderBottom__3UemD","title":"DefinitionList_title__1Bx9P"};